import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
  output,
} from '@angular/core';

let uiSwitchUid = 0;

/**
 * Átomo: toggle switch con thumb deslizante.
 * Sin apariencia nativa — 100% CSS con tokens del Design System.
 */
@Component({
  selector: 'ui-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.scss',
})
export class UiSwitchComponent {
  readonly checked = model(false);
  readonly label = input('');
  readonly description = input<string | undefined>(undefined);

  readonly required = input(false);
  readonly showOptionalHint = input(false);
  readonly requiredHint = input('Obligatorio');
  readonly optionalHint = input('Opcional');

  readonly disabled = input(false);
  readonly invalid = input(false);
  readonly message = input<string | undefined>(undefined);
  readonly showMessage = input(true);

  readonly name = input<string | undefined>(undefined);
  readonly fieldId = input<string | undefined>(undefined);

  readonly checkedChange = output<boolean>();
  readonly blurred = output<FocusEvent>();
  readonly focused = output<FocusEvent>();

  protected readonly generatedId = `ui-switch-${++uiSwitchUid}`;
  protected readonly inputId = computed(() => this.fieldId() ?? this.generatedId);
  protected readonly messageId = computed(() => `${this.inputId()}-message`);

  protected readonly ariaDescribedBy = computed(() => {
    const parts: string[] = [];
    if (this.description()) parts.push(`${this.inputId()}-desc`);
    if (this.message() && this.invalid()) parts.push(this.messageId());
    return parts.length ? parts.join(' ') : null;
  });

  protected readonly showRequirement = computed(
    () => this.required() || this.showOptionalHint(),
  );

  protected readonly requirementText = computed(() =>
    this.required() ? this.requiredHint() : this.optionalHint(),
  );

  protected onChange(event: Event): void {
    if (this.disabled()) return;
    const v = (event.target as HTMLInputElement).checked;
    this.checked.set(v);
    this.checkedChange.emit(v);
  }

  protected onBlur(event: FocusEvent): void {
    this.blurred.emit(event);
  }

  protected onFocus(event: FocusEvent): void {
    this.focused.emit(event);
  }
}
